import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

const LayoutWrapper = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100vh;
  overflow: hidden;
`;

const ContentArea = styled.main`
  flex: 1;
  padding: ${({ theme }) => theme.spacing.lg};
  overflow-y: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.spacing.md};
  }
`;

// Backdrop que oscurece el contenido cuando el menú está abierto en mobile.
// Tocarlo cierra el menú. Oculto en desktop (el sidebar es fijo ahí).
const Overlay = styled.div<{ $visible: boolean }>`
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: ${({ $visible }) => ($visible ? 'block' : 'none')};
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 90;
  }
`;

export function Layout() {
  // Estado del menú mobile vive acá para que el Header (hamburguesa) y el
  // Sidebar compartan la misma fuente de verdad. En desktop es irrelevante:
  // el sidebar es fijo y el Header está oculto.
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Cerrar el menú al navegar a otra ruta (mobile).
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <LayoutWrapper>
      <Sidebar isOpen={menuOpen} />
      <Overlay $visible={menuOpen} onClick={() => setMenuOpen(false)} />
      <MainContent>
        <Header onMenuClick={() => setMenuOpen(true)} />
        <ContentArea>
          <Outlet />
        </ContentArea>
      </MainContent>
    </LayoutWrapper>
  );
}
